<template>

<core-dropdown class="input" trigger="manual" v-on:forceClose="is.expanded = false" :expanded="is.expanded" v-click-outside="onOutsideClick">

	<core-button v-on:click.native="onToggleClick" tooltip="Views" :caret="true" theme="filter" icon="table-layout" :iconOnly="$isDesktop" :text="layoutName" :icon-left="$isMobile" />
	
	<core-dropdown-list title="Views" class="input-options" :expanded="is.expanded" theme="filter" :caret="true" align="left" type="button" v-on:close="is.expanded = false">

			<core-dropdown-item type="link" v-for="view in views" :key="view.id">{{ view.name }}</core-dropdown-item>

			<core-dropdown-item type="link" :is-ticked="true">Standard List</core-dropdown-item>
			<core-dropdown-item type="link">Standard Cards</core-dropdown-item>

			<template v-if="$isSelf">
			
				<core-dropdown-item type="divide" />

				<core-dropdown-item type="link" v-on:click.native.stop="onCreateClick">Create view</core-dropdown-item>
				<core-dropdown-item type="link" v-on:click.native.stop="onManageClick">Manage views</core-dropdown-item>

			</template>

	</core-dropdown-list>

</core-dropdown>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

	props: [
		'filter', 'page'
	],
	
	data: function() {

		return {
			is: {
				expanded: false
			}
		}

	},

	computed: {

		layoutName: function() {

			return '<b>List</b> view'

		},

		views: function() {

			return this.$store.getters['data/views/list']

		},

	},

	methods: {

		onCreateClick: function() {

			this.$pubsub.$emit('open.modal', 'viewsManageCreate')

			this.is.expanded = false

		},

		onManageClick: function() {

			this.$pubsub.$emit('open.modal', 'viewsManage')

			this.is.expanded = false

		},

		onToggleClick: function() {

			this.is.expanded = !this.is.expanded

		},

		onOutsideClick: function() {

			this.is.expanded = false

		}

	}

}

</script>

<style scoped>

</style>
